export default __webpack_public_path__ + "locales/pl/DeleteProfileEverDialog.json?hash=97927ca3b22d18471fd670b1505ba2d3";